import { Restore, Save } from '@mui/icons-material';
import { Button, DialogContentText } from '@mui/material';

import { ActionButtons, HistoryButtons } from 'components';
import { AppDialog } from 'components/Dialogs';
import strings from 'constants/index';
import { useDialogStatus } from 'hooks/common';

interface PermissionsActionsProps {
  isResetDisabled: boolean;
  isSaveDisabled: boolean;
  onReset: () => void;
  onSubmit: () => void;
}

export const PermissionsActions = ({
  isResetDisabled,
  isSaveDisabled,
  onReset,
  onSubmit,
}: PermissionsActionsProps) => {
  const { isOpen, onShow, onHide } = useDialogStatus();

  return (
    <>
      <ActionButtons>
        <HistoryButtons />
        <Button
          data-testid="reset"
          onClick={onShow}
          variant="contained"
          disabled={isResetDisabled}
          startIcon={<Restore />}
        >
          {strings.reset}
        </Button>
        <Button
          data-testid="save"
          onClick={onSubmit}
          variant="contained"
          disabled={isSaveDisabled}
          startIcon={<Save />}
        >
          {strings.save}
        </Button>
      </ActionButtons>
      <AppDialog
        open={isOpen}
        title={strings.warning}
        fullWidth={false}
        onClose={onHide}
        confirmButton={{
          label: strings.discard,
          props: {
            onClick: () => {
              onReset();
              onHide();
            },
          },
        }}
      >
        <DialogContentText>{strings.unsaved_changes}</DialogContentText>
      </AppDialog>
    </>
  );
};
